<template>
  <div id="custMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>客户设置</el-breadcrumb-item>
          <el-breadcrumb-item>客户信息管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px"
             class="pageSearch">
      <el-row>
        <el-col :span="22">
          <el-form-item label="客户类型">
            <el-select v-model="pageSearch.fCustTypeID"
                       clearable
                       placeholder="请选择类型">
              <el-option v-for="item in custTypeIDList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入客户编号/客户名称/软件名称"
                      v-model="pageSearch.searchKeyWord"
                      class="search">
              <!-- <i slot="prefix"
               class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item label="所属分组::">
            <el-select v-model="pageSearch.fGrpID"
                       clearable
                       @change="loadOptions($event,true)"
                       placeholder="请选择所属分组">
              <el-option v-for="item in groupList"
                         :key="item.fGrpID"
                         :label="item.fGrpName"
                         :value="item.fGrpID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员::">
            <el-select v-model="pageSearch.fUsrID"
                       clearable
                       placeholder="请选择业务员">
              <el-option v-for="item in search_userList"
                         :key="item.fUsrID"
                         :label="item.fUsrName"
                         :value="item.fUsrID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="2"
                class="searchRowAdd">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-edit"
                     v-if="is_edit"
                     @click="handleAdd">新增客户
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号"
                           align="right">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column label="客户类型"
                           width="80"
                           prop="fCustTypeID"
                           :formatter="formatType">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fSoftName"
                           label="软件名称">
          </el-table-column>
          <el-table-column prop="fStartDate"
                           label="创建时间"
                           width="100px"
                           align="center">
          </el-table-column>
          <el-table-column prop="park_num"
                           label="场库数量"
                           width="80px"
                           align="right">
            <!-- <template slot-scope="scope">
              <el-tag type="danger"
                      v-if="scope.row.park_list.length<=0">{{scope.row.park_list.length}}</el-tag>
              <el-dropdown v-else>
                <el-tag class="el-dropdown-link">{{scope.row.park_list.length}} <i class="el-icon-arrow-down el-icon--right"></i></el-tag>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(e,i) in scope.row.park_list"
                                    :key="i">{{e.fParkName}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template> -->
          </el-table-column>
          <el-table-column prop="fGrpName"
                           label="所属分组">
          </el-table-column>
          <el-table-column prop="fUsrName"
                           label="业务员">
          </el-table-column>
          <el-table-column prop="fAddress"
                           label="客户地址">
          </el-table-column>
          <!-- <el-table-column prop="fIsNet"
                           width="80px"
                           label="是否有网">
          </el-table-column> -->
          <!-- <el-table-column prop="fIsPicSvr"
                           width="80px"
                           label="上传图片">
          </el-table-column> -->
          <el-table-column prop="fRemark"
                           label="备注">
          </el-table-column>
          <!-- <el-table-column prop="fEndDate"
                           label="结束时间">
          </el-table-column> -->
          <!-- <el-table-column prop="IsWebIPAddr"
                           label="程序自动升级">
          </el-table-column>
          <el-table-column prop="IsPayIPAddr"
                           label="场库电子支付">
          </el-table-column>
          <el-table-column prop="IsImgIPAddr"
                           label="车辆图片上传">
          </el-table-column>
          <el-table-column prop="IsLogIPAddr"
                           label="程序日志上传">
          </el-table-column> -->
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="300">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_edit"
                         @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         v-if="is_del"
                         @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              <el-button size="mini"
                         type="info"
                         v-if="is_syn"
                         @click="synCust(scope.$index, scope.row)">上传</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               id="custDialog"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="cust"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建日期::"
                          prop="fStartDate">
              <el-date-picker v-model="cust.fStartDate"
                              type="date"
                              :disabled="formDisabled"
                              placeholder="创建日期"
                              style="width:100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属分组::"
                          prop="fGrpID">
              <el-select v-model="cust.fGrpID"
                         placeholder="请选择分组"
                         :disabled="fGrpDisabled"
                         style="width:100%"
                         @change="changeGrp">
                <el-option v-for="item in groupList"
                           :key="item.fGrpID"
                           :label="item.fGrpName"
                           :value="item.fGrpID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户类型::"
                          prop="fCustTypeID">
              <el-select v-model="cust.fCustTypeID"
                         :disabled="fCustTypeIDDisabled"
                         style="width:100%">
                <el-option v-for="item in custTypeIDList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户编号::"
                          prop="fCustNo">
              <el-input v-model="cust.fCustNo"
                        :disabled="fCustNoDisabled"
                        placeholder="请填写客户编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称::"
                          prop="fCustName">
              <el-input v-model="cust.fCustName"
                        :disabled="formDisabled"
                        placeholder="请填写客户名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="业务员::"
                          prop="fUsrID">
              <el-select v-model="cust.fUsrID"
                         :disabled="formDisabled"
                         placeholder="请选择业务员"
                         style="width:100%">
                <el-option v-for="item in userList"
                           :key="item.fUsrID"
                           :label="item.fUsrName"
                           :value="item.fUsrID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="软件标题::"
                          prop="fSoftName">
              <el-input v-model="cust.fSoftName"
                        :disabled="formDisabled"
                        placeholder="请填写软件名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="是否有网"
                          prop="fIsNet">
              <el-radio-group v-model="cust.fIsNet"
                              :disabled="formDisabled">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
                <el-form-item label="是否上传图片"
                              prop="fIsPicSvr">
                  <el-radio-group v-model="cust.fIsPicSvr"
                                  :disabled="formDisabled">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户联系人::"
                          prop="fLinkman">
              <el-input v-model="cust.fLinkman"
                        :disabled="formDisabled"
                        placeholder="请填写客户联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户联系电话::"
                          prop="fLinkPhone">
              <el-input v-model="cust.fLinkPhone"
                        :disabled="formDisabled"
                        placeholder="请填写客户联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户地址::"
                          prop="fAddress">
              <el-input v-model="cust.fAddress"
                        :disabled="formDisabled"
                        placeholder="请填写客户地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="备注::"
                          prop="fRemark">
              <el-input type="textarea"
                        v-model="cust.fRemark"
                        :disabled="formDisabled"
                        id="fRemark"
                        placeholder="请填写客户备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-tabs v-model="tabModel"
                 tab-position="left"
                 type="card"
                 @tab-click="tab_click">
          <el-tab-pane label="基本信息"
                       name="BaseInfo">

          </el-tab-pane>
          <el-tab-pane label="配置参数"
                       name="Setting">
            <el-row>
              <el-col :span="7">
                <el-form-item label=""
                              label-width="30px"
                              prop="IsWebIPAddr">
                  <el-checkbox v-model="cust.IsWebIPAddr">开通自动升级</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label=""
                              label-width="30px"
                              prop="IsPayIPAddr">
                  <el-checkbox v-model="cust.IsPayIPAddr">开通电子支付</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label=""
                              label-width="100px"
                              prop="IsLogIPAddr">
                  <el-checkbox v-model="cust.IsLogIPAddr">开通日志上传</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <el-form-item label=""
                              label-width="30px"
                              prop="IseInvIPAddr">
                  <el-checkbox v-model="cust.IseInvIPAddr">开通电子发票</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label=""
                              label-width="30px"
                              prop="IsImgIPAddr">
                  <el-checkbox v-model="cust.IsImgIPAddr">开通图片上传</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="10"
                      v-if="cust.IsImgIPAddr">
                <el-form-item label="图片保留天数"
                              prop="fPicSvrDays">
                  <el-select v-model="cust.fPicSvrDays"
                             style="width:200px"
                             placeholder="请选择保留天数">
                    <el-option v-for="item in picSvrDaysList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="在场数据上传"
                              prop="fUpCurTimes">
                  <el-select v-model="cust.fUpCurTimes"
                             style="width:200px;"
                             filterable
                             placeholder="在场数据上传轮询次数">
                    <el-option v-for="item in upCurTimesList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="历史数据上传"
                              label-width="170px"
                              prop="fUpHisTimes">
                  <el-select v-model="cust.fUpHisTimes"
                             style="width:200px;"
                             filterable
                             placeholder="历史数据上传轮询次数">
                    <el-option v-for="item in upHisTimesList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上传开始时间"
                              prop="fStartUpTime">
                  <el-date-picker v-model="cust.fStartUpTime"
                                  :clearable="false"
                                  style="width:200px;"
                                  type="date"
                                  placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs> -->
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!formDisabled">保存</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <!-- <el-row style="margin-top:-1px">
        <el-col :span="12">
          <div class="tab_foot">&nbsp;</div>
        </el-col>
        <el-col :span="12">
          <div class="dialog-footer">
            <el-button type="primary"
                       @click="submitForm('ruleForm')"
                       v-if="!formDisabled">保存</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </div>
        </el-col>
      </el-row> -->
    </el-dialog>
  </div>
</template>
<script>
import { cust as api } from '../../api/cust'
import * as user from '../../api/user'
// import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    // var validateDate = (rule, value, callback) => {
    //   if (!this.cust.fStartDate) {
    //     callback(new Error('请选择开始日期'))
    //   }
    //   if (!this.cust.fEndDate) {
    //     callback(new Error('请选择结束日期'))
    //   }
    //   if (this.cust.fEndDate < this.cust.fStartDate) {
    //     callback(new Error('结束日期不能小于开始日期'))
    //   }
    //   callback()
    // }
    var validateCustNo = (rule, value, callback) => {
      if ((this.fGrpNo || '').length > 0) {
        var len = 6 - this.fGrpNo.length
        var re = new RegExp('^' + this.fGrpNo + '\\d{' + len + '}$')
        if (!re.test(value)) {
          callback(new Error('请填写六位的数字（必须以' + this.fGrpNo + '开头）'))
        }
      } else {
        if (!/^\d{6}$/.test(value)) {
          callback(new Error('请填写六位的数字'))
        }
      }
      callback()
    }
    return {
      is_edit: false,
      is_del: false,
      is_syn: false,
      is_export: false,
      export_loading: false,
      formDisabled: false,
      export_msg: '导出',
      tableHeight: 0,
      fGrpNo: '',
      custTypeIDList: [{ value: '0', label: '封闭式场库' }, { value: '1', label: '路侧场库' }],
      // picSvrDaysList: [{ value: 7, label: '7天' }, { value: 90, label: '90天' }, { value: 180, label: '180天' }, { value: 360, label: '360天' }],
      // upCurTimesList: [],
      // upHisTimesList: [],
      dialogFormVisible: false,
      fCustNoDisabled: false,
      fGrpDisabled: false,
      fCustTypeIDDisabled: false,
      loading: true,
      dialogTitle: '',
      pageData: [],
      search_userList: [],
      userList: [],
      groupList: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        isExport: 0,
        fCustTypeID: '',
        fGrpID: '',
        fUsrID: '',
        searchKeyWord: ''
      },
      cust: {
        fCustNo: '',
        fCustName: '',
        fSoftName: '',
        fStartDate: '',
        fEndDate: '',
        fGrpID: '',
        fUsrID: '',
        fAddress: '',
        fRemark: '',
        fLinkman: '',
        fLinkPhone: '',
        fCustTypeID: '0'
        // fIsPicSvr: '0',
        // fPicSvrDays: 7,
        // fIsNet: '0'
        // IsWebIPAddr: false,
        // IsPayIPAddr: false,
        // IsImgIPAddr: false,
        // IsLogIPAddr: false,
        // IseInvIPAddr: false,
        // fUpCurTimes: 5,
        // fUpHisTimes: 11,
        // fStartUpTime: new Date()

      },
      rules: {
        fCustNo: [
          { required: true, message: '请输入客户编号', trigger: 'blur' },
          { validator: validateCustNo, trigger: 'blur' }
        ],
        fCustName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        fSoftName: [
          { required: true, message: '请输入软件名称', trigger: 'blur' }
        ],
        fStartDate: [
          // { validator: validateDate, trigger: 'change' },
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        fUsrID: [
          { required: true, message: '请选择业务员', trigger: 'change' }
        ],
        fGrpID: [{ required: true, message: '请选择所属分组', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.init()
      }, 1000)
    },
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.pageSearch.isExport = 0
      this.loading = true
      api.custPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载客户信息失败')
          }
        }
      })
    },
    exportData () {
      this.export_loading = true
      this.export_msg = '导出中……'
      this.pageSearch.isExport = 1
      api.custPageList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, '客户列表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    changeGrp (obj) {
      var group = this.groupList.find(r => r.fGrpID === obj)
      if (group) {
        if (!(this.cust.fCustNo || '').trim().length > 0) {
          this.cust.fCustNo = group.fGrpNo
        }
        this.fGrpNo = group.fGrpNo
        this.$refs['ruleForm'].validateField('fCustNo', (errorMsg) => {
        })
      }
      this.loadOptions(obj, false)
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleInfo (index, row) {
      this.dialogTitle = '查看客户'
      this.fGrpDisabled = true
      this.fCustTypeIDDisabled = true
      this.fCustNoDisabled = true
      this.formDisabled = true
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.userList = []
      this.dialogFormVisible = true
      // setTimeout(() => {
      //   this.setTabHeight()
      // }, 100)
      api.custInfo(row.fCustID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            data.Data = data.Data || {}
            this.loadOptions(data.Data.fGrpID, false)
            if (data.Data.fGrpID === '0') {
              data.Data.fGrpID = ''
            }
            if (data.Data.fUsrID === '0') {
              data.Data.fUsrID = ''
            }
            this.cust = data.Data
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleEdit (index, row) {
      this.dialogTitle = '编辑客户'
      this.fCustNoDisabled = false
      // this.fGrpDisabled = false
      this.fCustTypeIDDisabled = false
      this.formDisabled = false
      if (row.park_num > 0) {
        // this.fGrpDisabled = true
        this.fCustNoDisabled = true
        this.fCustTypeIDDisabled = true
      }
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.userList = []
      this.dialogFormVisible = true
      // setTimeout(() => {
      //   this.setTabHeight()
      // }, 100)
      api.custInfo(row.fCustID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            data.Data = data.Data || {}
            // if (data.Data.fWebIPAddr1) {
            //   data.Data.IsWebIPAddr = true
            // } else {
            //   data.Data.IsWebIPAddr = false
            // }
            // if (data.Data.fPayIPAddr1) {
            //   data.Data.IsPayIPAddr = true
            // } else {
            //   data.Data.IsPayIPAddr = false
            // }
            // if (data.Data.fImgIPAddr1) {
            //   data.Data.IsImgIPAddr = true
            // } else {
            //   data.Data.IsImgIPAddr = false
            // }
            // if (data.Data.fLogIPAddr1) {
            //   data.Data.IsLogIPAddr = true
            // } else {
            //   data.Data.IsLogIPAddr = false
            // }
            this.loadOptions(data.Data.fGrpID, false)
            if (data.Data.fGrpID === '0') {
              data.Data.fGrpID = ''
            }
            if (data.Data.fUsrID === '0') {
              data.Data.fUsrID = ''
            }
            this.cust = data.Data
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleDelete (index, row) {
      this.$confirm('此操作将永久删除该客户[' + row.fCustName + '], 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.custDelete(row.fCustID).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.init()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    synCust (index, row) {
      this.$confirm('将客户[' + row.fCustName + ']的基础数据从线下客户端上传同步到云平台, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.synCust(row.fCustID).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: '操作完成'
                })
                // this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      }).catch(() => { })
    },
    handleAdd () {
      this.dialogTitle = '新增客户'
      this.userList = []
      this.cust = {
        fCustNo: '',
        fCustName: '',
        fSoftName: 'RedParking停车软件',
        fStartDate: this.$dateFormat(new Date(), 'yyyy-MM-dd'),
        fGrpID: '',
        fUsrID: '',
        fAddress: '',
        fRemark: '',
        fLinkman: '',
        fLinkPhone: '',
        fCustTypeID: '0'
        // fIsPicSvr: '0',
        // fPicSvrDays: 7,
        // fIsNet: '0'
        // IsWebIPAddr: false,
        // IsPayIPAddr: false,
        // IsImgIPAddr: false,
        // IsLogIPAddr: false,
        // IseInvIPAddr: false,
        // fUpCurTimes: 5,
        // fUpHisTimes: 11,
        // fStartUpTime: new Date()
      }
      setTimeout(() => {
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate()
        }
      }, 50)
      this.formDisabled = false
      this.dialogFormVisible = true
      this.fCustNoDisabled = false
      this.fGrpDisabled = false
      this.fCustTypeIDDisabled = false
      // setTimeout(() => {
      //   this.setTabHeight()
      // }, 100)
    },
    formatType (row, column, cellValue, index) {
      if (cellValue === '0') {
        return '封闭式'
      } else {
        return '路侧'
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          if (this.cust.fStartDate instanceof Date) {
            this.cust.fStartDate = this.$dateFormat(this.cust.fStartDate, 'yyyy-MM-dd')
          }
          // if (this.cust.fEndDate instanceof Date) {
          //   this.cust.fEndDate = this.$dateFormat(this.cust.fEndDate, 'yyyy-MM-dd')
          // }
          api.custEdit(this.cust).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init(this.pageSearch.pageIndex)
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    tab_click (tab) {
      // this.setTabHeight($('#' + tab.$el.id).height())
    },
    // setTabHeight (contentHeight) {
    //   var height = $('#custDialog .el-tabs__content').height()
    //   if (this.tab_height <= 0) {
    //     this.tab_height = $('#custDialog .el-tabs__nav-scroll').height()
    //   }
    //   if (contentHeight) {
    //     $('#custDialog .el-tabs__nav-scroll').css('height', (this.tab_height > contentHeight ? this.tab_height : contentHeight) + 'px')
    //   } else {
    //     $('#custDialog .el-tabs__nav-scroll').css('height', (height > this.tab_height ? height : this.tab_height) + 'px')
    //   }
    // },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 220
      obj.tableHeight = clientHeight
    },
    loadOptions (val, isSearch) {
      if (isSearch) {
        this.search_userList = []
        this.pageSearch.fUsrID = ''
      } else {
        this.cust.fUsrID = ''
        this.userList = []
      }
      api.allCustUser(val).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (isSearch) {
              this.search_userList = data.Data || []
            } else {
              this.userList = data.Data || []
            }
          } else {
            this.$message.error('加载业务员失败')
          }
        }
      })
    },
    loadGroups () {
      api.groupList().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.groupList = data.Data
          } else {
            this.$message.error('加载所属分组失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 40000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    this.loadGroups()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#custMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#custMain .el-dialog__title {
  color: white;
}
#custMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#custMain .el-dialog__body {
  padding: 30px 20px 0px 20px;
}
#custMain .is-disabled .el-input__inner,
#custMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#custMain #fRemark {
  height: 180px;
}
#custMain .fRemark_row .el-form-item__content {
  height: 180px;
}
/* tab 样式 */
/* #custMain #custDialog .el-tabs__item {
  padding: 0px 20px 0px 0px;
}
#custMain #custDialog .el-tabs__nav-scroll {
  background-color: #ccc;
  text-align: center;
  width: 100px;
  overflow: auto;
}
#custMain #custDialog .el-tabs__nav-next,
#custMain #custDialog .el-tabs__nav-prev {
  display: none;
}
#custMain #custDialog .el-tabs__nav-wrap.is-scrollable {
  padding: 0px !important;
}
#custMain #custDialog .el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border: none !important;
}
#custMain #custDialog .el-tabs__item:hover {
  color: white;
  background-color: #409eff;
}
#custMain #custDialog .el-tabs--left.el-tabs--card .el-tabs__nav {
  border-bottom: none;
}
#custMain #custDialog .el-tabs__nav {
  margin-top: -1px;
  margin-left: -1px;
}
#custMain #custDialog .el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
} */
</style>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/cust/custMain.vue